export const MAX_ENTRIES_PER_KIND = 10
export const TTL_DAYS = 30
export const SCHEMA_VERSION = 1
export const DAY_IN_MS = 24 * 60 * 60 * 1000
